// Powers /dashboard/shared-with-me — papers that other people have invited
// the current user into. Backed by the `list_for_user` edge action.
import { useQuery } from '@tanstack/react-query';
import { collaboratorsApi, type SharedWithMeRow } from '@/lib/api/collaborators';

export const sharedWithMeQueryKey = ['shared-with-me'] as const;

export function useSharedWithMe(enabled = true) {
  return useQuery<{ rows: SharedWithMeRow[] }>({
    queryKey: sharedWithMeQueryKey,
    queryFn: () => collaboratorsApi.listForUser(),
    enabled,
    staleTime: 60_000,
  });
}
